/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-05-11 17:35:31
 * @msg: 获取日期范围时间戳
 */
import { ref} from "vue";

export function useDateTimestamp(formData){
    const startDate = ref('')
    const endDate = ref('')

    startDate.value = new Date(`
        ${formData.date[0].$y}-
        ${formData.date[0].$M + 1}-
        ${formData.date[0].$D} 00:00:00
    `)
    .getTime()
    .toString()
    .slice(0,10)

    endDate.value = new Date(`
        ${formData.date[1].$y}-
        ${formData.date[1].$M + 1}-
        ${formData.date[1].$D} 23:59:59
    `)
    .getTime()
    .toString()
    .slice(0,10)

    return {
        startDate,
        endDate
    }
}

export function newUseDateTimestamp(date){
    const startDate = ref('')
    const endDate = ref('')

    startDate.value = new Date(`
        ${date[0].$y}-
        ${date[0].$M + 1}-
        ${date[0].$D} 00:00:00
    `)
    .getTime()
    .toString()
    .slice(0,10)

    endDate.value = new Date(`
        ${date[1].$y}-
        ${date[1].$M + 1}-
        ${date[1].$D} 23:59:59
    `)
    .getTime()
    .toString()
    .slice(0,10)

    return {
        startDate,
        endDate
    }
}